import templateUrl from "emun.order/order-details-prompt.htm";
import controller from "emun.order/order-details-prompt.controller";
import resolve from "ioc/resolve";
import modals from "webmodals/modals";
import ContactPrompt from "emun.customer/contact-prompt";
import config from "emun.retailer/retailer.config";
import authConfig from "emun.auth/auth.config";
import registerRetailerPromptFormIO from "emun.auth/register-retailer.prompt";
import "emun.order/order-details-prompt.scss";
import ScanBadge from "emun.customer/scan-badge/scan-badge";

const done = () => null;

const reject = (failed = {}) => {
  if (failed.createCustomer) {
    if (config.quickStartCustomer) {
      resolve("retailerPrompt")
        .start()
        .then((retailer) => {
          const retailerId = retailer.meta.RetailerId || retailer.id;
          orderDetailPrompt({
            model: Object.assign(failed.createCustomer, {
              retailerId,
              retailer: {
                id: retailerId,
                companyName: retailer.companyName,
              },
            }),
          });
        })
        .catch(() => orderDetailPrompt({ model: failed.createCustomer }));
    } else if (authConfig.registrationCRM) {
      if (authConfig.formIORegistration) {
        registerRetailerPromptFormIO({})
          .then((retailer) => {
            const retailerId = retailer.meta.RetailerId || retailer.id;
            orderDetailPrompt({
              model: Object.assign(failed.createCustomer, {
                retailerId,
                retailer: {
                  id: retailerId,
                  companyName: retailer.companyName,
                },
              }),
            });
          })
          .catch(() => orderDetailPrompt({ model: failed.createCustomer }));
      }
    } else {
      resolve("retailerPrompt")
        .add()
        .then((retailer) => {
          const retailerId = retailer.meta.RetailerId || retailer.id;
          orderDetailPrompt({
            model: Object.assign(failed.createCustomer, {
              retailerId,
              retailer: {
                id: retailerId,
                companyName: retailer.companyName,
              },
            }),
          });
        })
        .catch(() => orderDetailPrompt({ model: failed.createCustomer }));
    }
  } else if (failed.createShippingLocation) {
    resolve("retailerShippingLocationPrompt")
      .add(failed.createShippingLocation)
      .then((loc) =>
        orderDetailPrompt({
          model: Object.assign(failed.createShippingLocation, {
            retailerId: loc.retailerId,
            shippingLocationId: loc.id,
            shippingLocation: loc,
          }),
        })
      )
      .catch(() => orderDetailPrompt({ model: failed.createShippingLocation }));
  } else if (failed.createContact) {
    ContactPrompt.open({
      model: { customer: failed.createContact.retailer },
    })
      .then((con) =>
        orderDetailPrompt({
          model: Object.assign(failed.createContact, {
            buyer: con.contact.name,
            createContactEmail: con.contact.email
          }),
        })
      )
      .catch(() => orderDetailPrompt({ model: failed.createContact }));
  } else if (failed.scanBadge) {
    ScanBadge.open({startOrder: true})
      .then((retailer) => {
        const retailerId = retailer.meta.RetailerId || retailer.id;
        orderDetailPrompt({
          model: Object.assign(failed.scanBadge, {
            retailerId,
            retailer: {
              id: retailerId,
              companyName: retailer.companyName,
            },
          }),
        });
      })
      .catch(() => orderDetailPrompt({ model: failed.scanBadge }));
  // } else if (failed.directOrder) {
  //   modals.confirm("Direct order placed for $" + failed.directOrder.summaryTotal + ".  Would you like to create another order?").result.then(function() {
  //     console.debug("BL*** failed.directOrder", failed.directOrder);
  //     orderDetailPrompt({
  //       model: Object.assign(failed.directOrder, {
  //         summary: true,
  //         summaryTotal: 0,
  //         balanceTotal: 0,
  //         purchaseOrder: "",
  //         shipOn: null,
  //         orderedOn: null
  //       })
  //     });
  //   });
  }
};

export const orderDetailPrompt = (options) => {
  const prom = modals.open(
    Object.assign(
      {
        size: "xl",
        templateUrl,
        resolve: {
          options: () => options,
        },
        bindToController: true,
        controller,
        controllerAs: "$ctrl",
      },
      (options || {}).modal
    )
  ).result;

  prom.then(done, reject);

  return prom;
};

export default { open: orderDetailPrompt };
